import * as React from "react"
import { Route } from "wouter"
import "./app.css"
import { Header } from "blog/components/header"
import { Home } from "blog/pages/home"
import { About } from "blog/pages/about"
import {PopcornIsHighInProtein} from 'blog/posts/2020-05-13-popcorn-is-high-in-protein'
import {DarrellLeaLicoriceDarkChocolateBlock} from 'blog/posts/2020-06-01-darrell-lea-licorice-dark-chocolate-block'
import {LetsTalkAboutStock} from 'blog/posts/2020-06-04-lets-talk-about-stock'
import {GetACat} from 'blog/posts/2020-07-29-get-a-cat'
import {IncrementalProductAndEngineering} from 'blog/posts/2020-08-05-incremental-product-and-engineering'
import {HowDoIPutGoLangProjectAnywhere} from 'blog/posts/2020-06-30-how-do-i-put-go-lang-project-anywhere'
import {TrainingMyCat01} from 'blog/posts/2020-08-14-training-my-cat-01'


const item = localStorage.getItem("isDark")
const initialIsDark = item ? JSON.parse(item) : false
export const MyApp = () => {
  const [isDark, setDark] = React.useState(initialIsDark)
  const onThemeChange = () => {
    localStorage.setItem("isDark", JSON.stringify(!isDark))
    setDark(!isDark)
  }
  const bodyClassName = ["Body", isDark && "Body--dark", isDark && "dark"]
    .filter(x => !!x)
    .join(" ")
  const mainClassName = ["Main", isDark && "Main--dark"]
    .filter(x => !!x)
    .join(" ")

  return (
    <div className={bodyClassName}>
      <div className={mainClassName}>
        <Header onThemeChange={onThemeChange} />
        <div className="Content">
          <Route path="/" component={Home} />
          <Route path="/about" component={About} />

          <Route path="/posts/popcorn-is-high-in-protein" component={PopcornIsHighInProtein} />
          <Route path="/posts/darrell-lea-licorice-dark-chocolate-block" component={DarrellLeaLicoriceDarkChocolateBlock} />
          <Route path="/posts/lets-talk-about-stock" component={LetsTalkAboutStock} />
          <Route path="/posts/how-do-i-put-go-lang-project-anywhere" component={HowDoIPutGoLangProjectAnywhere} />
          <Route path="/posts/get-a-cat" component={GetACat} />
          <Route path="/posts/incremental-product-and-engineering" component={IncrementalProductAndEngineering} />
          <Route path="/posts/training-my-cat-01" component={TrainingMyCat01} />
        </div>
      </div>
    </div>
  )
}

export const App = <MyApp />
